<template>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card>
          <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
          <ul class="m-list-wrapper">
            <li>
              <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
            </li>
            <li>
              <a-collapse :activeKey="getScreen ? 0 : 1">
                <a-collapse-panel key="1">
                  <span slot="header">Search More...</span>
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Transaction Date</label>
                    <a-date-picker placeholder="Select Date" v-model="searchDate" :disabled="triggerSearch"
                      :format="getDefaultDateFormat" allowClear />
                  </div>
  
                  <div class="m-form-item-wrapper">
                    <label for="director">Director</label>
                    <a-select placeholder="Choose director" v-model="director" :disabled="triggerSearch" class="width-full"
                      initialValue="undefined" allowClear>
                      <a-select-option v-for="item in listDirector" :key="item.value" :value="item.value">{{ item.text
                      }}</a-select-option>
                    </a-select>
                  </div>
  
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Status</label>
                    <a-select placeholder="Ex: Approved ... " v-model="status" :disabled="triggerSearch" class="width-full"
                      initialValue="delivered" allowClear>
                      <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                      }}</a-select-option>
                    </a-select>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <DataList 
            title="Credit Card Ticket Claim List" 
            :tabbed="getAuth.divisi[0] == 'HRD' ? true : false"
            :dataList="searching"
            :draftList="draftList"
            :loading="loading" 
            :price="true" 
            :manifestLink="getAuth.divisi[0] == 'HRD' ? 'manifest_klaim_tiket' : 'manifest_klaim_tiket_monitoring'" 
            createLink="create_klaim_tiket"
            draftEditLink="edit_klaim_tiket"
            editLink="revise_klaim_tiket"
            :disabledCreateEditLink="getAuth.divisi[0] == 'HRD' ? false : true"
        />
      </a-col>
    </a-row>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import axios from "axios";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import _ from "lodash";
  
  export default {
    name: "klaimCcTiket",
    props: ["prnMenu"],
    mixins: [CurrencyFormat],
    data() {
      return {
        loading: true,
        dataList: [],
        draftList: [],
        basedList: [],
        listDirector: [],
        searchDate: null,
        search: "",
        status: undefined,
        director: undefined,
        triggerSearch: false,
      };
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getStatus",
        "getDefaultDateFormat",
        "getStandartFormatDate",
      ]),
      searching() {
        var self = this;
        let outputData = this.dataList;
  
        if (this.search) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }
  
        if (this.searchDate) {
          let filter = moment(this.searchDate).format(this.getStandartFormatDate);
          outputData = _.filter(outputData, { tgl_buat: filter });
        }
  
        if (this.director) {
          outputData = outputData.filter(
            (obj) =>
              obj.tlc_bod &&
              obj.tlc_bod.toLowerCase().indexOf(self.director.toLowerCase()) >= 0
          );
        }
  
        if (this.status) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
          );
        }
  
        return outputData;
      },
      getManifestLink() {
        if (localStorage.getItem("nvpn") === "/keuangan") {
          return "manifest_klaim_tiket";
        } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
          return "SpclKlaimCCManifestACC";
        } else if (localStorage.getItem("nvpn") === "/pimpro") {
          return "klaim-direktur-pimpro-manifest";
        } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
          return "SpclKlaimCcManifestVP";
        } else if (localStorage.getItem("nvpn") === "/vpf") {
          return "SpclKlaimDirekturManifestVpf";
        } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
          return "SpclKlaimCCManifestFin";
        } else {
          return "KlaimDirekturManifest";
        }
      },
    },
    created() {
      this.fetchData();
    },
    mounted() {
      Event.$on("callbackTab", this.clickTabed);
      
    },
    beforeDestroy() {
      Event.$off("callbackTab", this.clickTabed);
    },
    methods: {
      moment,
      async fetchData() {
      const laporan = axios({
        method: "get",
        url: this.$serviceUrl + "lap_tiket_pd",
        params: {
          tlc: this.getAuth.username,
          jenis: "Laporan",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const draft = axios({
        method: "get",
        url: this.$serviceUrl + "lap_tiket_pd",
        params: {
          tlc: this.getAuth.username,
          jenis: "Draft",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return await axios
        .all([
          laporan.catch((err) => {
            return null;
          }),
          draft.catch((err) => {
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {
            response[0].data.data.forEach((data) => {
              this.dataList.push({
                title: data.no_transaksi,
                subdesc: {
                  tanggal: moment(data.report_date).format(
                    this.getDefaultDateFormat
                  ),
                },
                tgl_buat: data.report_date,
                status: data.status,
                id: data.id_laporan,
                price: data.total,
                cancelStatus: data.cancel_sts
                  ? data.cancel_sts == 1
                    ? "Canceled"
                    : null
                  : null,
              });
            });
          } else {
            this.dataList = [];
            this.basedList = [];
          }
          if (response[1] !== undefined) {
            response[1].data.data.forEach((data, i) => {
              this.draftList.push({
                title: "Draft " + (i + 1),
                subdesc: [
                  moment(data.report_date).format(this.getDefaultDateFormat),
                ],
                status: data.status,
                id: data.id_laporan,
                price: data.grand_total,
              });
            });
          } else {
            this.draftList = [];
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //   fetchData() {
    //     axios({
    //       method: "get",
    //       url: this.$serviceUrl + "lap_tiket_pd",
    //       params: {
    //         tlc: this.getAuth.username,
    //         id: localStorage.getItem("nvky"),
    //         jenis: 'laporan'
    //       },
    //       auth: {
    //         username: this.getAuth.username,
    //         password: this.getAuth.password,
    //       },
    //       headers: {
    //         "X-API-KEY": this.getAuth.apikey,
    //       },
    //     }).then((response) => {
    //         this.listDirector = response.data.director;
    //         _.forEach(response.data.data, (data) => {
    //           this.dataList.push({
    //             title: data.no_transaksi,
    //             timeline: JSON.parse(data.status_app),
    //             unread: data.unread == "1" ? true : false,
    //             subdesc: {
    //               tanggal: moment(data.report_date).format(
    //                 this.getDefaultDateFormat
    //               )
    //             },
    //             status: data.status,
    //             id: data.id_laporan,
    //             price: data.total,
    //             cancelStatus: data.cancel_sts,
    //             create_date: data.report_date,
    //             searchQ:
    //               data.no_klaim_cc + " " + data.tlc_pic + " " + data.tlc,
    //             tlc_bod: data.tlc_bod,
    //           });
    //         });
  
    //         this.loading = false;
    //       })
    //       .catch((err) => {
    //         this.loading = false;
    //       });
    //   },
      clickTabed(val) {
        this.search = "";
        this.searchDate = undefined;
        this.director = undefined;
        this.status = undefined;
        if (val == "draft") {
          this.triggerSearch = true;
        } else {
          this.triggerSearch = false;
        }
      },
    },
  };
  </script>
  
  <style></style>
  